import EducationList from './EducationList';

export default EducationList;
